(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-announcement"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.sh-ann__msgs').forEach(function (w) {
      if (w.dataset.on) return;
      w.dataset.on = 1;
      var m = w.querySelectorAll('.sh-ann__m'), i = 0;
      if (m.length < 2 || window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
      setInterval(function () {
        m[i].classList.remove('is-on');
        i = (i + 1) % m.length;
        m[i].classList.add('is-on');
      }, (+w.dataset.speed) || 4000);
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-grocery-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() { document.querySelectorAll('.sh-gl__app').forEach(setup); }
  function setup(root) {
    if (root.dataset.on) return;
    root.dataset.on = 1;
    var $ = function (s) { return root.querySelector(s); };
    var grid = $('.sh-gl__grid'), msg = $('.sh-gl__msg'), cur = root.dataset.money || 'R';
    var base = { cid: root.dataset.cid, ts: root.dataset.ts, sig: root.dataset.sig };
    var known = {}, order = [], sel = {}, colSet = null, MAX = 120;
    function say(t, bad) { msg.textContent = t; msg.className = 'sh-gl__msg' + (bad ? ' is-bad' : ''); }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function api(p, extra) {
      return fetch(root.dataset.api + p, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(Object.assign({}, base, extra || {})) })
        .then(function (r) { return r.json(); });
    }
    function fetchProducts(handle) {
      var url = handle ? '/collections/' + handle + '/products.json' : '/products.json', all = [];
      function page(n) {
        return fetch(url + '?limit=250&page=' + n).then(function (r) { return r.json(); }).then(function (d) {
          var p = d.products || []; all = all.concat(p);
          return (p.length === 250 && n < 8) ? page(n + 1) : all;
        });
      }
      return page(1);
    }
    function addKnown(products) {
      products.forEach(function (p) {
        (p.variants || []).forEach(function (v) {
          var id = String(v.id);
          if (!known[id]) order.push(id);
          var img = '';
          (p.images || []).forEach(function (im) { if (!img && ((im.variant_ids || []).indexOf(v.id) > -1 || (v.image_id && im.id === v.image_id))) img = im.src; });
          if (!img && v.featured_image) img = v.featured_image.src;
          if (!img && p.images && p.images[0]) img = p.images[0].src;
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=200';
          known[id] = { id: id, pid: p.id, name: p.title + (v.title && v.title !== 'Default Title' ? ' - ' + v.title : ''), price: parseFloat(v.price) || 0, img: img, ok: v.available !== false };
        });
      });
    }
    function money(n) { return cur + n.toFixed(2); }
    function renderNote() {
      var out = [], n = 0, t = 0;
      order.forEach(function (id) {
        var it = known[id];
        if (!sel[id] || !it) return;
        n += sel[id]; t += it.price * sel[id];
        out.push("<li><span class='sh-gl__nq'>" + sel[id] + '&times;</span><span class=\'sh-gl__nn\'>' + esc(it.name) + "</span><button type='button' data-rm='" + id + "' aria-label='Remove " + esc(it.name) + "'>&times;</button></li>");
      });
      $('.sh-gl__nl').innerHTML = out.length ? out.join('') : "<li class='sh-gl__ne'>Nothing here yet. Tap the items you buy every month and they will be stuck on this note.</li>";
      $('.sh-gl__nsum').textContent = n ? 'About ' + money(t) : '';
      $('.sh-gl__fabn').textContent = n;
    }
    function summary() {
      var n = 0, t = 0;
      Object.keys(sel).forEach(function (id) { n += sel[id]; if (known[id]) t += known[id].price * sel[id]; });
      $('.sh-gl__cart').disabled = !n;
      renderNote();
      $('.sh-gl__count').textContent = n + (n === 1 ? ' item' : ' items') + (n ? ' - about ' + money(t) : '');
    }
    function render() {
      var q = $('.sh-gl__q').value.trim().toLowerCase(), mine = $('.sh-gl__mine').checked, out = [], shown = 0, total = 0;
      order.forEach(function (id) {
        var it = known[id];
        if (!it) return;
        if (mine && !sel[id]) return;
        if (colSet && !colSet[it.pid]) return;
        if (q && it.name.toLowerCase().indexOf(q) === -1) return;
        total++;
        if (shown >= MAX) return;
        shown++;
        var on = !!sel[id];
        out.push("<div class='sh-gl__card" + (on ? ' is-on' : '') + (it.ok ? '' : ' is-off') + "' data-id='" + id + "'>" +
          (it.img ? "<img class='sh-gl__img' src='" + esc(it.img) + "' alt='' loading='lazy'>" : "<div class='sh-gl__img'></div>") +
          "<div class='sh-gl__info'><span class='sh-gl__name'>" + esc(it.name) + "</span><span class='sh-gl__price'>" + money(it.price) + (it.ok ? '' : ' - out of stock') + "</span>" +
          "<div class='sh-gl__qty'><button type='button' data-d='-1' aria-label='Less'>-</button><span>" + (sel[id] || 1) + "</span><button type='button' data-d='1' aria-label='More'>+</button></div></div>" +
          '</div>');
      });
      grid.innerHTML = out.length ? out.join('') : "<p class='sh-gl__load'>" + (mine ? 'Nothing in your list yet. Untick "My list only" and tap items to add them.' : 'No products found.') + '</p>';
      if (total > MAX) grid.insertAdjacentHTML('beforeend', "<p class='sh-gl__load'>Showing the first " + MAX + ' of ' + total + ' products. Use the search to find more.</p>');
      summary();
    }
    grid.addEventListener('click', function (e) {
      var card = e.target.closest('.sh-gl__card');
      if (!card) return;
      var id = card.dataset.id, it = known[id], b = e.target.closest('button');
      if (!it || !it.ok) return;
      if (b) { sel[id] = Math.min(99, Math.max(1, (sel[id] || 1) + parseInt(b.dataset.d, 10))); }
      else if (sel[id]) { delete sel[id]; } else { sel[id] = 1; }
      say('');
      render();
    });
    $('.sh-gl__nl').addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      delete sel[b.dataset.rm]; say(''); render();
    });
    function openNote(o) { $('.sh-gl__note').classList.toggle('is-open', o); $('.sh-gl__scrim').classList.toggle('is-on', o); }
    $('.sh-gl__fab').addEventListener('click', function () { openNote(true); });
    $('.sh-gl__x').addEventListener('click', function () { openNote(false); });
    $('.sh-gl__scrim').addEventListener('click', function () { openNote(false); });
    $('.sh-gl__q').addEventListener('input', render);
    $('.sh-gl__mine').addEventListener('change', render);
    $('.sh-gl__c').addEventListener('change', function () {
      var h = this.value;
      if (!h) { colSet = null; render(); return; }
      grid.innerHTML = "<p class='sh-gl__load'>Loading...</p>";
      fetchProducts(h).then(function (ps) { colSet = {}; ps.forEach(function (p) { colSet[p.id] = 1; }); addKnown(ps); render(); })
        .catch(function () { say('Could not load that category.', true); });
    });
    $('.sh-gl__save').addEventListener('click', function () {
      var btn = this, items = Object.keys(sel).map(function (id) { return { v: id, q: sel[id] }; });
      btn.disabled = true; say('Saving...');
      api('/list/save', { items: items }).then(function (d) { say(d.ok ? 'Your list is saved! It will be here next month.' : (d.message || 'Could not save.'), !d.ok); })
        .catch(function () { say('Could not reach the server. Try again.', true); })
        .then(function () { btn.disabled = false; });
    });
    $('.sh-gl__cart').addEventListener('click', function () {
      var btn = this, ids = Object.keys(sel).filter(function (id) { return known[id] && known[id].ok; });
      if (!ids.length) { say('Add some items to your list first.', true); return; }
      var items = Object.keys(sel).map(function (id) { return { v: id, q: sel[id] }; });
      btn.disabled = true; say('Getting your checkout ready...');
      api('/list/save', { items: items }).catch(function () {})
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          var have = {};
          (cart.items || []).forEach(function (i) { have[String(i.variant_id)] = i.quantity; });
          var add = ids.map(function (id) { return { id: Number(id), quantity: sel[id] - (have[id] || 0) }; }).filter(function (i) { return i.quantity > 0; });
          if (!add.length) return;
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: add }) })
            .then(function (r) { if (!r.ok) throw new Error(); });
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { say('Some items could not be added. Please check stock and try again.', true); btn.disabled = false; });
    });
    Promise.all([fetchProducts(''), api('/list/get')]).then(function (res) {
      addKnown(res[0]);
      if (res[1].ok) { (res[1].items || []).forEach(function (i) { if (known[String(i.v)]) sel[String(i.v)] = i.q; }); }
      else { say(res[1].message || 'Could not load your saved list.', true); }
      render();
    }).catch(function () { grid.innerHTML = "<p class='sh-gl__load'>Could not load products. Please refresh.</p>"; });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
